export const PROFORMA_STARGATE_URL_PREFIX = '/gateway/api/proforma/portal/cloudid';

export const JSM_CUSTOMER_PORTAL_URL_PREFIX = '/rest/servicedesk/1/customer/portal';

export const APOLLO_STARGATE_URL_PREFIX = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
